import React, { useEffect, useState } from "react";
import axios from "../axios";

/**
 * 解析している営業所を選ぶ。
 *
 * ## 決め打ちにしない
 *
 * 各ページが `const DEFAULT_DEPOT = "アイランド"` を持っていた。営業所が
 * 1 つしかないうちは動くが、足したときに**URL を手で書き換えないと辿り
 * つけない**。乗番がある営業所は API が知っているので、そこから採る。
 *
 * ## 1 つしかないうちは出さない
 *
 * 選べる先が 1 つの選択肢は、置いてあるだけで読み手の手を止める。
 * 2 つ以上になったら出す。
 *
 * 出どころは /analysis/duties/availability（乗番が抽出できている営業所）。
 * **目撃があるだけの営業所は出さない。**乗番が無ければ、どの画面も
 * 中身が空になる。
 */
export default function DepotSelect({ depot, onChange }) {
  const [depots, setDepots] = useState([]);

  useEffect(() => {
    axios
      .get("/analysis/duties/availability")
      .then((res) => setDepots(Array.isArray(res.data) ? res.data : []))
      .catch(() => setDepots([]));
  }, []);

  if (depots.length < 2) return null;

  return (
    <label className="anl-depot-select">
      <span className="anl-depot-select__label">営業所</span>
      <select
        className="anl-select"
        value={depot}
        onChange={(e) => onChange(e.target.value)}
      >
        {depots.map((d) => (
          <option key={d.depot} value={d.depot}>
            {d.depot_name || d.depot}
          </option>
        ))}
      </select>
    </label>
  );
}

/**
 * 既定の営業所。**アイランドを決め打ちしない。**
 *
 * URL に指定があればそれ。無ければ、乗番がある営業所のうち先頭
 * （API が sort_id 順に返す）。まだ読めていないあいだは null を返し、
 * 呼び出し側は読み込み中として扱う。
 */
export function useDepot(searchParams, setSearchParams) {
  const fromUrl = searchParams.get("depot") || "";
  const [fallback, setFallback] = useState(null);

  useEffect(() => {
    if (fromUrl) return;
    axios
      .get("/analysis/duties/availability")
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        setFallback(list[0]?.depot ?? "");
      })
      .catch(() => setFallback(""));
  }, [fromUrl]);

  const depot = fromUrl || fallback;
  const setDepot = (next) => {
    const params = new URLSearchParams(searchParams);
    params.set("depot", next);
    setSearchParams(params);
  };

  return [depot, setDepot];
}
